import React from "react";
import styles from "./FullScreen.module.scss";

class FullScreenButton extends React.Component{
    render(){
        return (
            <div className={styles.fullscreen_btn} onClick={this.props.openFullscreen}>
            <i class="fas fa-expand"></i>
            <span className={styles.fullscreen_tooltip}>Full screen</span>
        </div>
        )
    }
}

export default FullScreenButton;